export interface Drama {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  posterImage: string;
  description: string;
  shortDescription: string;
  rating: number;
  year: number;
  totalEpisodes: number;
  genres: string[];
  status: string;
  updateInfo: string;
  director: string;
  cast: string[];
  region: string;
  episodes: { number: number; title: string; }[];
}

export const dramaCategories = [
  { name: '全部', slug: 'all' },
  { name: '热播推荐', slug: 'hot' },
  { name: '国产剧', slug: 'chinese' },
  { name: '韩剧', slug: 'korean' },
  { name: '美剧', slug: 'american' },
  { name: '日剧', slug: 'japanese' },
  { name: '泰剧', slug: 'thai' },
];

export const dramas: Drama[] = [
  {
    id: 'drama-1',
    title: '长安十二时辰',
    category: '国产剧',
    categorySlug: 'chinese',
    posterImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20costume%20drama%20poster%20featuring%20a%20solemn%20male%20lead%20in%20Tang%20Dynasty%20armor%20standing%20in%20front%20of%20ancient%20Changan%20city%20gate%20at%20night%2C%20cinematic%20lighting%2C%20mysterious%20atmosphere%2C%20warm%20amber%20and%20dark%20tones%2C%20epic%20historical%20drama%20aesthetic%2C%20clean%20poster%20design%20with%20dramatic%20shadows&width=600&height=800&seq=drama-poster-1&orientation=portrait',
    description: '《长安十二时辰》是由曹盾执导，雷佳音、易烊千玺领衔主演的古装悬疑剧。该剧改编自马伯庸的同名小说，讲述了唐朝上元节前夕，长安城陷入危局，长安死囚张小敬临危受命，与李必携手在十二时辰内拯救长安的故事。剧情紧凑，制作精良，被誉为国产古装剧的标杆之作。',
    shortDescription: '唐朝上元节前夕，死囚张小敬临危受命，十二时辰内拯救长安城。',
    rating: 8.2,
    year: 2019,
    totalEpisodes: 48,
    genres: ['古装', '悬疑', '历史'],
    status: '已完结',
    updateInfo: '全48集',
    director: '曹盾',
    cast: ['雷佳音', '易烊千玺', '周一围', '热依扎'],
    region: '中国大陆',
    episodes: Array.from({ length: 48 }, (_, i) => ({ number: i + 1, title: `第${i + 1}集` })),
  },
  {
    id: 'drama-2',
    title: '狂飙',
    category: '国产剧',
    categorySlug: 'chinese',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20poster%20with%20two%20men%20in%20sharp%20contrast%2C%20one%20in%20police%20uniform%20and%20another%20in%20dark%20suit%2C%20intense%20standoff%20atmosphere%2C%20dark%20cinematic%20tones%20with%20red%20accents%2C%20modern%20urban%20Chinese%20setting%2C%20clean%20poster%20design%20with%20dramatic%20lighting&width=600&height=800&seq=drama-poster-2&orientation=portrait',
    description: '《狂飙》是由徐纪周执导，张译、张颂文、李一桐、张志坚、吴刚领衔主演的反黑刑侦剧。该剧讲述了以一线刑警安欣为代表的正义力量，与黑恶势力长达二十年的生死搏斗故事，通过群像叙事展现扫黑行动中的黑白较量与复杂人性。',
    shortDescription: '一线刑警与黑恶势力长达二十年的生死较量，黑白交锋震撼人心。',
    rating: 8.5,
    year: 2023,
    totalEpisodes: 39,
    genres: ['刑侦', '反黑', '剧情'],
    status: '已完结',
    updateInfo: '全39集',
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚', '吴刚'],
    region: '中国大陆',
    episodes: Array.from({ length: 39 }, (_, i) => ({ number: i + 1, title: `第${i + 1}集` })),
  },
  {
    id: 'drama-3',
    title: '黑暗荣耀',
    category: '韩剧',
    categorySlug: 'korean',
    posterImage: 'https://readdy.ai/api/search-image?query=Korean%20revenge%20drama%20poster%20featuring%20an%20elegant%20woman%20with%20cold%20expression%20wearing%20dark%20clothing%2C%20minimalist%20design%20with%20dark%20background%20and%20subtle%20golden%20light%2C%20sophisticated%20Korean%20drama%20aesthetic%2C%20clean%20poster%20composition%2C%20mysterious%20atmosphere&width=600&height=800&seq=drama-poster-3&orientation=portrait',
    description: '《黑暗荣耀》是由安吉镐执导，金银淑编剧，宋慧乔、李到晛、林智妍、郑星一主演的复仇题材韩剧。该剧讲述了曾在高中时期遭受校园暴力而退学的文同珢，多年后向加害者和旁观者进行彻底报复的故事。剧情环环相扣，情感张力十足。',
    shortDescription: '校园暴力受害者精心策划多年，向所有加害者展开彻底复仇。',
    rating: 8.9,
    year: 2022,
    totalEpisodes: 16,
    genres: ['复仇', '悬疑', '剧情'],
    status: '已完结',
    updateInfo: '全16集',
    director: '安吉镐',
    cast: ['宋慧乔', '李到晛', '林智妍', '郑星一'],
    region: '韩国',
    episodes: Array.from({ length: 16 }, (_, i) => ({ number: i + 1, title: `第${i + 1}集` })),
  },
  {
    id: 'drama-4',
    title: '漫长的季节',
    category: '国产剧',
    categorySlug: 'chinese',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20suspense%20drama%20poster%20set%20in%20northeastern%20China%20with%20three%20men%20of%20different%20ages%2C%20autumn%20leaves%20and%20industrial%20background%2C%20nostalgic%20warm%20amber%20tones%2C%20mysterious%20and%20melancholic%20atmosphere%2C%20clean%20poster%20design%2C%20artistic%20composition&width=600&height=800&seq=drama-poster-4&orientation=portrait',
    description: '《漫长的季节》是由辛爽执导，范伟、秦昊、陈明昊领衔主演的生活悬疑剧。该剧讲述了出租车司机王响和妹夫龚彪联手调查套牌车案的过程中，串联起18年前的碎尸悬案，在老 industrial 城市背景下展开一场跨越时空的人性探索。',
    shortDescription: '一桩套牌车案牵出18年前的碎尸悬案，三个男人跨越时空寻找真相。',
    rating: 9.4,
    year: 2023,
    totalEpisodes: 12,
    genres: ['悬疑', '剧情', '家庭'],
    status: '已完结',
    updateInfo: '全12集',
    director: '辛爽',
    cast: ['范伟', '秦昊', '陈明昊', '李庚希'],
    region: '中国大陆',
    episodes: Array.from({ length: 12 }, (_, i) => ({ number: i + 1, title: `第${i + 1}集` })),
  },
  {
    id: 'drama-5',
    title: '财阀家的小儿子',
    category: '韩剧',
    categorySlug: 'korean',
    posterImage: 'https://readdy.ai/api/search-image?query=Korean%20drama%20poster%20featuring%20a%20young%20man%20in%20luxurious%20suit%20standing%20in%20front%20of%20a%20grand%20corporate%20building%2C%20split%20personality%20visual%20concept%2C%20rich%20golden%20and%20dark%20tones%2C%20dramatic%20lighting%2C%20Korean%20drama%20aesthetic%2C%20clean%20poster%20design&width=600&height=800&seq=drama-poster-5&orientation=portrait',
    description: '《财阀家的小儿子》是由郑大允执导，宋仲基、李星民主演的奇幻复仇剧。该剧讲述被诬陷私吞资金而被财阀家杀害的尹炫优，重生后成为杀死自己的财阀家的小儿子，为了侵吞整个财阀家族而展开复仇计划的故事。',
    shortDescription: '被财阀家族杀害后重生为仇家的小儿子，展开一场精心策划的复仇。',
    rating: 7.8,
    year: 2022,
    totalEpisodes: 16,
    genres: ['奇幻', '复仇', '商战'],
    status: '已完结',
    updateInfo: '全16集',
    director: '郑大允',
    cast: ['宋仲基', '李星民', '申铉彬'],
    region: '韩国',
    episodes: Array.from({ length: 16 }, (_, i) => ({ number: i + 1, title: `第${i + 1}集` })),
  },
  {
    id: 'drama-6',
    title: '三体',
    category: '国产剧',
    categorySlug: 'chinese',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20poster%20inspired%20by%20Three%20Body%20Problem%2C%20cosmic%20background%20with%20three%20suns%2C%20mysterious%20red%20glow%2C%20futuristic%20and%20philosophical%20atmosphere%2C%20clean%20poster%20design%20with%20dramatic%20sci-fi%20aesthetic%2C%20dark%20and%20crimson%20tones&width=600&height=800&seq=drama-poster-6&orientation=portrait',
    description: '《三体》是由杨磊执导，张鲁一、于和伟、陈瑾、王子文、林永健、李小冉领衔主演的科幻剧。该剧改编自刘慈欣同名科幻小说，讲述了纳米科学家汪淼与刑警史强共同揭开地外文明"三体"世界的神秘面纱，并随全人类一道与即将入侵的三体人展开博弈的故事。',
    shortDescription: '纳米科学家与刑警共同揭开外星文明的神秘面纱，全人类面临前所未有的挑战。',
    rating: 8.0,
    year: 2023,
    totalEpisodes: 30,
    genres: ['科幻', '悬疑', '剧情'],
    status: '已完结',
    updateInfo: '全30集',
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文', '林永健', '李小冉'],
    region: '中国大陆',
    episodes: Array.from({ length: 30 }, (_, i) => ({ number: i + 1, title: `第${i + 1}集` })),
  },
  {
    id: 'drama-7',
    title: '非常律师禹英禑',
    category: '韩剧',
    categorySlug: 'korean',
    posterImage: 'https://readdy.ai/api/search-image?query=Korean%20legal%20drama%20poster%20featuring%20a%20young%20female%20lawyer%20with%20quirky%20expression%20wearing%20formal%20attire%2C%20bright%20and%20warm%20color%20palette%2C%20whimsical%20illustration%20style%20with%20whale%20motif%2C%20uplifting%20Korean%20drama%20aesthetic%2C%20clean%20poster%20design&width=600&height=800&seq=drama-poster-7&orientation=portrait',
    description: '《非常律师禹英禑》是由刘仁植执导，朴恩斌、姜泰伍、姜其永主演的律政题材韩剧。该剧讲述了拥有天才头脑的自闭症谱系障碍律师禹英禑，作为韩国顶级律所的新人律师，面对法庭内外各种偏见与挑战，用自己独特的方式解决案件并成长的故事。',
    shortDescription: '自闭症天才律师用独特视角解决案件，温暖治愈的律政故事。',
    rating: 8.7,
    year: 2022,
    totalEpisodes: 16,
    genres: ['律政', '治愈', '剧情'],
    status: '已完结',
    updateInfo: '全16集',
    director: '刘仁植',
    cast: ['朴恩斌', '姜泰伍', '姜其永'],
    region: '韩国',
    episodes: Array.from({ length: 16 }, (_, i) => ({ number: i + 1, title: `第${i + 1}集` })),
  },
  {
    id: 'drama-8',
    title: '莲花楼',
    category: '国产剧',
    categorySlug: 'chinese',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20drama%20poster%20with%20an%20elegant%20male%20swordsman%20in%20white%20robe%20standing%20among%20lotus%20flowers%20in%20misty%20lake%2C%20ethereal%20atmosphere%2C%20soft%20warm%20lighting%2C%20traditional%20Chinese%20ink%20painting%20aesthetic%2C%20clean%20poster%20design&width=600&height=800&seq=drama-poster-8&orientation=portrait',
    description: '《莲花楼》是由郭虎、任海涛执导，成毅、曾舜晞、肖顺尧、陈都灵领衔主演的古装武侠悬疑剧。该剧讲述了闻名武林的四顾门门主李相夷在一次大战后身受重伤，从此退隐江湖成为淡泊名利的郎中李莲花，在遇到新友与旧敌后重新卷入江湖的故事。',
    shortDescription: '昔日武林盟主重伤隐退，以郎中身份重新卷入江湖恩怨。',
    rating: 8.1,
    year: 2023,
    totalEpisodes: 40,
    genres: ['武侠', '悬疑', '古装'],
    status: '已完结',
    updateInfo: '全40集',
    director: '郭虎',
    cast: ['成毅', '曾舜晞', '肖顺尧', '陈都灵'],
    region: '中国大陆',
    episodes: Array.from({ length: 40 }, (_, i) => ({ number: i + 1, title: `第${i + 1}集` })),
  },
  {
    id: 'drama-9',
    title: '少年歌行',
    category: '国产剧',
    categorySlug: 'chinese',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20fantasy%20drama%20poster%20with%20young%20warriors%20in%20colorful%20robes%20wielding%20swords%2C%20dynamic%20action%20pose%2C%20ancient%20Chinese%20landscape%20background%20with%20mountains%20and%20clouds%2C%20vibrant%20warm%20colors%2C%20epic%20fantasy%20aesthetic%2C%20clean%20poster&width=600&height=800&seq=drama-poster-9&orientation=portrait',
    description: '《少年歌行》是由尹涛执导，李宏毅、刘学义、林博洋、敖瑞鹏、李欣泽、戴燕妮领衔主演的古装武侠剧。初出茅庐的少年侠客雷无桀，慕名前往江湖第一大城雪月城的途中误入雪落山庄，因一场意外卷入江湖纷争，与萧瑟、无心等一众少年英雄携手共闯江湖。',
    shortDescription: '少年侠客闯荡江湖，与伙伴们携手谱写热血传奇。',
    rating: 8.3,
    year: 2022,
    totalEpisodes: 40,
    genres: ['武侠', '奇幻', '古装'],
    status: '已完结',
    updateInfo: '全40集',
    director: '尹涛',
    cast: ['李宏毅', '刘学义', '林博洋', '敖瑞鹏'],
    region: '中国大陆',
    episodes: Array.from({ length: 40 }, (_, i) => ({ number: i + 1, title: `第${i + 1}集` })),
  },
  {
    id: 'drama-10',
    title: '我的大叔',
    category: '韩剧',
    categorySlug: 'korean',
    posterImage: 'https://readdy.ai/api/search-image?query=Korean%20melodrama%20poster%20with%20a%20middle-aged%20man%20and%20young%20woman%20walking%20together%20on%20a%20quiet%20neighborhood%20street%20at%20night%2C%20warm%20street%20lamp%20lighting%2C%20melancholic%20but%20hopeful%20atmosphere%2C%20realistic%20Korean%20drama%20aesthetic%2C%20clean%20poster%20design&width=600&height=800&seq=drama-poster-10&orientation=portrait',
    description: '《我的大叔》是由金元锡执导，朴惠英编剧，李善均、IU（李知恩）主演的都市情感剧。该剧讲述了承担生活重压的40多岁男性朴东勋，与同样承受着生活重担的20多岁女性李至安，互相观察、互相治愈对方的故事，是一部温暖治愈的人性剧。',
    shortDescription: '两个背负生活重担的人相遇，互相治愈彼此的温暖故事。',
    rating: 9.1,
    year: 2018,
    totalEpisodes: 16,
    genres: ['剧情', '治愈', '都市'],
    status: '已完结',
    updateInfo: '全16集',
    director: '金元锡',
    cast: ['李善均', 'IU', '朴浩山', '宋清晨'],
    region: '韩国',
    episodes: Array.from({ length: 16 }, (_, i) => ({ number: i + 1, title: `第${i + 1}集` })),
  },
  {
    id: 'drama-11',
    title: '去有风的地方',
    category: '国产剧',
    categorySlug: 'chinese',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20healing%20romance%20drama%20poster%20with%20a%20couple%20standing%20in%20a%20beautiful%20rural%20Yunnan%20style%20village%20with%20green%20rice%20fields%20and%20blue%20sky%2C%20warm%20sunlight%2C%20relaxing%20and%20healing%20atmosphere%2C%20natural%20and%20fresh%20aesthetic%2C%20clean%20poster%20design&width=600&height=800&seq=drama-poster-11&orientation=portrait',
    description: '《去有风的地方》是由丁梓光执导，刘亦菲、李现领衔主演的田园治愈剧。该剧讲述了辞职后来到云南短住的许红豆，意外邂逅了放弃高薪回乡创业的谢之遥，两人在大理云苗村互相治愈、互生情愫的温暖故事。',
    shortDescription: '辞职后来到云南乡村，治愈心灵的同时遇见爱情。',
    rating: 8.4,
    year: 2023,
    totalEpisodes: 40,
    genres: ['治愈', '爱情', '田园'],
    status: '已完结',
    updateInfo: '全40集',
    director: '丁梓光',
    cast: ['刘亦菲', '李现', '胡冰卿', '牛骏峰'],
    region: '中国大陆',
    episodes: Array.from({ length: 40 }, (_, i) => ({ number: i + 1, title: `第${i + 1}集` })),
  },
  {
    id: 'drama-12',
    title: '请回答1988',
    category: '韩剧',
    categorySlug: 'korean',
    posterImage: 'https://readdy.ai/api/search-image?query=Korean%20retro%20drama%20poster%20with%20five%20teenage%20friends%20sitting%20together%20in%20a%20cozy%20room%20filled%20with%201980s%20Korean%20decor%2C%20warm%20nostalgic%20yellow%20tones%2C%20friendship%20and%20family%20themed%20Korean%20drama%20aesthetic%2C%20clean%20poster%20design&width=600&height=800&seq=drama-poster-12&orientation=portrait',
    description: '《请回答1988》是由申源浩执导，李惠利、朴宝剑、柳俊烈、高庚杓等主演的青春怀旧剧。该剧以1988年汉城奥运会为背景，讲述在首尔市道峰区双门洞居住的五家人的故事，描绘温暖的亲情、邻里街坊小市民传统的爱情与友情。',
    shortDescription: '1988年首尔双门洞，五个家庭温暖的亲情与青春故事。',
    rating: 9.7,
    year: 2015,
    totalEpisodes: 20,
    genres: ['青春', '家庭', '喜剧'],
    status: '已完结',
    updateInfo: '全20集',
    director: '申源浩',
    cast: ['李惠利', '朴宝剑', '柳俊烈', '高庚杓'],
    region: '韩国',
    episodes: Array.from({ length: 20 }, (_, i) => ({ number: i + 1, title: `第${i + 1}集` })),
  },
];

export const hotDramas = dramas.filter(d => ['drama-1', 'drama-2', 'drama-3', 'drama-4', 'drama-5', 'drama-6'].includes(d.id));
export const chineseDramas = dramas.filter(d => d.categorySlug === 'chinese');
export const koreanDramas = dramas.filter(d => d.categorySlug === 'korean');
export const latestDramas = [...dramas].sort((a, b) => b.year - a.year);

export const getDramaById = (id: string): Drama | undefined => dramas.find(d => d.id === id);
export const getDramasByCategory = (slug: string): Drama[] => {
  if (slug === 'all') return dramas;
  if (slug === 'hot') return hotDramas;
  return dramas.filter(d => d.categorySlug === slug);
};